import { useQuery } from "@tanstack/react-query";

import { ListIntegrationsQueryFilters, UseListIntegrationsQueryOptions } from "./types";
import { getIntegrationsService } from "./service";

export const listIntegrationsQueryKey = ["v1/integration_admin"];

export function useListIntegrationsQuery(
  filters?: ListIntegrationsQueryFilters,
  options?: UseListIntegrationsQueryOptions
) {
  const queryKey = listIntegrationsQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getIntegrationsService(filters),
    ...options,
  });
}
